// extracted by mini-css-extract-plugin
export default {"label":"SelectComponent_label__w9Ofr","content":"SelectComponent_content__nADt5"};